module.exports = __webpack_public_path__ + "static/media/landing-bg.6f3c67c0.png";